import { useState } from "react";
import { Plane, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { fmtDate, todayIST } from "@/lib/format";

export function PauseManager({ pauses = [], onAdd, onRemove, prefix = "pause" }) {
  const [start, setStart] = useState(todayIST(1));
  const [end, setEnd] = useState(todayIST(3));
  const [busy, setBusy] = useState(false);
  const add = async () => { setBusy(true); try { await onAdd(start, end); } finally { setBusy(false); } };
  return (
    <div className="space-y-3" data-testid={`${prefix}-manager`}>
      {pauses.length === 0 && <div className="text-sm text-muted-foreground">No holidays planned.</div>}
      {pauses.map((p) => (
        <div key={p.id} className="flex items-center justify-between rounded-xl border border-sky-200 bg-sky-50 px-3 py-2 text-sm" data-testid={`${prefix}-item-${p.id}`}>
          <span className="flex items-center gap-2"><Plane className="h-4 w-4 text-sky-700" />{fmtDate(p.start)} → {fmtDate(p.end)}</span>
          <Button variant="ghost" size="icon" onClick={() => onRemove(p.id)} data-testid={`${prefix}-remove-${p.id}`}><Trash2 className="h-4 w-4" /></Button>
        </div>
      ))}
      <div className="grid grid-cols-2 gap-2">
        <div><div className="text-xs text-muted-foreground mb-1">From</div><Input type="date" min={todayIST(1)} value={start} onChange={(e) => setStart(e.target.value)} data-testid={`${prefix}-start`} /></div>
        <div><div className="text-xs text-muted-foreground mb-1">To</div><Input type="date" min={start} value={end} onChange={(e) => setEnd(e.target.value)} data-testid={`${prefix}-end`} /></div>
      </div>
      <Button disabled={busy} onClick={add} variant="outline" className="w-full border-sky-300 text-sky-800 hover:bg-sky-50" data-testid={`${prefix}-add`}>
        <Plane className="mr-2 h-4 w-4" />Pause deliveries for these dates
      </Button>
    </div>
  );
}
